export class ViewPathConstants {
  // Root
  rootViewPath = "/";

  // Public Routes
  landingViewPath = "/";
  loginViewPath = "/login";
  registerViewPath = "/register";
  forgotPasswordViewPath = "/forgot-password";
  otpViewPath = "/verify-otp";
  verifyTOTPViewPath = "/verify-code";
  setupMFAViewPath = "/setup-mfa";
  resetPasswordViewPath = "/changepwd";

  pageNotFoundViewPath = "/page-not-found";
  registrationSuccessViewPath = "/registered";
  verificationPendingViewPath = "/pending-verification";

  // Authenticated Routes
  dashboardViewPath = "/dashboard";
  applicantsViewPath = "/applicants";
  addApplicantsViewPath = `${this.applicantsViewPath}/add`;
  viewApplicantsViewPath = `${this.applicantsViewPath}/view`;
  viewApplicantCommentViewPath = `${this.applicantsViewPath}/view/comment`;
  editApplicantsViewPath = `${this.applicantsViewPath}/edit`;
  jobPostingsViewPath = "/job-postings";
  addJobPostingViewPath = `${this.jobPostingsViewPath}/add`;
  addJobPostingByCsvViewPath = `${this.jobPostingsViewPath}/add-by-csv`;
  viewJobPostingViewPath = `${this.jobPostingsViewPath}/view`;
  submissionJobPostingViewPath = `${this.jobPostingsViewPath}/submission`;
  editJobPostingViewPath = `${this.jobPostingsViewPath}/edit`;
  clientsViewPath = "/clients";
  addClientViewPath = `${this.clientsViewPath}/add`;
  editClientViewPath = `${this.clientsViewPath}/edit`;
  viewClientViewPath = `${this.clientsViewPath}/view`;
  facilitiesViewPath = `/facilities`;
  addFacilityViewPath = `${this.facilitiesViewPath}/add`;
  editFacilityViewPath = `${this.facilitiesViewPath}/update`;
  viewFacilityViewPath = `${this.facilitiesViewPath}/view`;
  settingsViewPath = "/settings";
  addUserViewPath = `${this.settingsViewPath}/user/add`;
  editUserViewPath = `${this.settingsViewPath}/user/edit`;
  addRolesViewPath = `${this.settingsViewPath}/roles/add`;
  editRolesViewPath = `${this.settingsViewPath}/roles/edit`;
  marginCalcViewPath = "/margin-calculator";
  healthWorkerViewPath = "/health-worker";
  addHealthWorkerViewPath = `${this.healthWorkerViewPath}/add`;
  editHealthWorkerViewPath = `${this.healthWorkerViewPath}/edit`;
  viewHealthWorkerViewPath = `${this.healthWorkerViewPath}/view`;
  timesheetViewPath = "/timesheets";
  viewTimesheetViewPath = `${this.timesheetViewPath}/view`;
  invoicesViewPath = "/invoices";
  viewInvoiceViewPath = `${this.invoicesViewPath}/view`;
  editInvoiceViewPath = `${this.invoicesViewPath}/edit`;
  profileViewPath = "/profile";
  editProfileViewPath = `${this.profileViewPath}/edit`;
  documentViewPath = "/documents";
  vendorViewPath = "/vendors";
  viewVendorViewPath = `${this.vendorViewPath}/view`;
  addVendorViewPath = `${this.vendorViewPath}/add`;
  editVendorViewPath = `${this.vendorViewPath}/edit`;
  billsViewPath = "/bills";
  viewBillsViewPath = `${this.billsViewPath}/view`;
  editBillsViewPath = `${this.billsViewPath}/edit`;
  addBillsViewPath = `${this.billsViewPath}/add`;
  expenseViewPath = `/expenses`;
  healthWorkerViewExpenseViewPath = `${this.expenseViewPath}/view`;
  viewExpenseViewPath = `${this.healthWorkerViewPath}/expenses/view`;
  editExpenseViewPath = `${this.healthWorkerViewPath}/expenses/edit`;
  addExpenseViewPath = `${this.healthWorkerViewPath}/expenses/add`;
  addContractsViewPath = `${this.healthWorkerViewPath}/contract/add`;
  addPreExpenseViewPath = `${this.healthWorkerViewPath}/pre-expenses/add`;
  viewPreExpenseViewPath = `${this.healthWorkerViewPath}/pre-expenses/view`;
  editPreExpenseViewPath = `${this.healthWorkerViewPath}/pre-expenses/edit`;

  contactsViewPath = `/contacts`;
  importantContactsViewPath = `${this.contactsViewPath}/import`;
  viewContactViewPath = `${this.contactsViewPath}/view`;
  groupsViewPath = `${this.contactsViewPath}/groups`;
  viewGroupsViewPath = `${this.groupsViewPath}/view`;
  tagsViewPath = `${this.contactsViewPath}/tags`;
  viewTagViewPath = `${this.tagsViewPath}/view`;

  campaignsViewPath = `/campaigns`;
  CampaignStatsViewPath = `${this.campaignsViewPath}/view`;

  createRegularCampaignViewPath = `/create-regular-campaign`;
  createSocialCampaignViewPath = `/create-social-campaign`;
  createABTestCampaignViewPath = `/create-ab-campaign`;
  createSequentialCampaignViewPath = `/create-sequential-campaign`;
  createResendCampaignViewPath = `/create-resend-campaign`;
  createRetargetCampaignViewPath = `/create-retarget-campaign`;

  templatesViewPath = `/templates`;
  templateDesignViewPath = `${this.templatesViewPath}/design`;
  integrationsViewPath = `/integration`;

  reportsViewPath = `/reports`;
  recipientDomainsViewPath = `${this.reportsViewPath}/recipient-domains`;
  failedStatsViewPath = `${this.reportsViewPath}/failed-stats`;
  reportingViewPath = `/reporting`;

  myProfileViewPath = `${this.settingsViewPath}/profile`;
  securityViewPath = `${this.settingsViewPath}/security`;
  viewMyPlanViewPath = `${this.settingsViewPath}/my-plan`;
  rolesViewPath = `${this.settingsViewPath}/roles`;
  usersViewPath = `${this.settingsViewPath}/users`;
  viewUserViewPath = `${this.usersViewPath}/view`;
  checkout = `${this.settingsViewPath}/my-plan/checkout`;
  domainsViewPath = `${this.settingsViewPath}/domains`;
  ticketsViewPath = `${this.settingsViewPath}/tickets`;
  viewTicketsViewPath = `${this.ticketsViewPath}/view`;

  onBoardCheckoutViewPath = `/onboard`;
}

const viewpaths = new ViewPathConstants();
export default viewpaths;
